export var IconButtonStyles = function (props) {
    var theme = props.theme;
    if (!theme) {
        throw new Error('Theme is undefined or null.');
    }
    var palette = theme.palette;
    return {
        root: {
            backgroundColor: 'transparent',
            color: palette.themePrimary
        },
        rootHovered: {
            backgroundColor: palette.neutralLighter,
            color: palette.themeDarkAlt
        },
        rootPressed: {
            backgroundColor: palette.neutralLight,
            color: palette.themeDark
        },
        rootChecked: {
            backgroundColor: palette.neutralLight,
            color: palette.themeDark
        },
        rootDisabled: {
            selectors: {
                '@media(forced-colors: active)': {
                    backgroundColor: 'ButtonFace'
                }
            },
            backgroundColor: 'transparent',
            color: palette.neutralTertiary
        }
    };
};
//# sourceMappingURL=IconButton.styles.js.map